"use strict";
import Honeybadger from "@honeybadger-io/js";
import { environment } from "./environment";
var FieldToCheck = /* @__PURE__ */ ((FieldToCheck2) => {
  FieldToCheck2[FieldToCheck2["Message"] = 0] = "Message";
  FieldToCheck2[FieldToCheck2["Name"] = 1] = "Name";
  return FieldToCheck2;
})(FieldToCheck || {});
const errorRules = [
  // https://app.honeybadger.io/projects/129900/faults/116707082/01JJD1CZ7Z34BVBAWND1NAMFY1?q=occurred.after%3A%221+hour+ago%22
  {
    field: 0 /* Message */,
    regex: /Could not find image or canvas for initialization/i,
    chanceToReport: 0.01
  },
  // https://app.honeybadger.io/projects/129900/faults/116707129?q=occurred.after%3A%221+hour+ago%22
  {
    field: 0 /* Message */,
    regex: /Cannot read properties of undefined \(reading '.+'\)/,
    chanceToReport: 0.01
  },
  // https://app.honeybadger.io/projects/129900/faults/116707120/01JJD2E7CN1Y5HVXBQ5DN04MVN?q=occurred.after%3A%221+hour+ago%22
  {
    field: 0 /* Message */,
    regex: /UnhandledPromiseRejectionWarning: Unspecified reason/,
    chanceToReport: 0.01
  },
  // https://app.honeybadger.io/projects/129900/faults/116707090/01JJD2J660KNM5B3SWXF6Q2WSP?q=occurred.after%3A%221+hour+ago%22
  {
    field: 0 /* Message */,
    regex: /Minified exception occurred/,
    chanceToReport: 0.01
  }
];
function errorRuleApplies(rule, notice) {
  switch (rule.field) {
    case 0 /* Message */:
      return rule.regex.test(notice.message);
    case 1 /* Name */:
      return rule.regex.test(notice.name);
  }
}
let configureHoneybadger = () => {
  Honeybadger.beforeNotify((notice) => {
    let errorRule = errorRules.find((pattern) => errorRuleApplies(pattern, notice));
    if (errorRule && Math.random() > errorRule.chanceToReport) {
      return false;
    }
  });
  Honeybadger.configure({
    apiKey: "hbp_pK6ftncuQjrdFT8zusl6J3YsibncEO15TUu7",
    environment: environment(),
    // https://docs.honeybadger.io/lib/javascript/guides/reducing-noise/#limit-bandwidth-browser-only-
    maxErrors: 5
  });
};
configureHoneybadger();
let reportDecodingError = (report) => {
  Auth.currentUser().then((user) => {
    let json = void 0;
    try {
      json = JSON.parse(report.json);
    } catch (e) {
    }
    const context = {
      user_id: user.id,
      account_id: user.account.id,
      account_alias: user.account.alias,
      json
    };
    const payload = {
      name: report.name,
      tags: "elm",
      message: report.message,
      fingerprint: report.fingerprint,
      context
    };
    Honeybadger.notify(payload);
  });
};
export { reportDecodingError };
